/**
 * Root Redirect Component
 * Redirects to the appropriate project or organization page based on current state
 */

import { html, attr, type Renderable } from '@tempots/dom'
import { NavigationService } from '@tempots/ui'
import { Workspace } from '@/state/workspace'

export function RootRedirect(): Renderable {
  // Ensure workspace is initialized
  Workspace.loadWorkspace().then(() => {
    const projectId = Workspace.projectId.get()
    const orgId = Workspace.organizationId.get()
    if (projectId) {
      NavigationService.navigate(`/p/${projectId}`, { replace: true })
    } else if (orgId) {
      NavigationService.navigate(`/o/${orgId}`, { replace: true })
    } else {
      NavigationService.navigate('/organizations', { replace: true })
    }
  })

  // Show loading spinner while determining redirect
  return html.div(
    attr.class('min-h-screen flex items-center justify-center'),
    html.div(
      attr.class('text-center'),
      html.div(
        attr.class(
          'animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600 mx-auto mb-4'
        )
      ),
      html.p(attr.class('text-gray-500 text-sm'), 'Loading workspace...')
    )
  )
}
